import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const DropdownWrapper = styled.div(
    () => css`
        display: flex;
    `
);

export const LeftWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-right: ${spacing['8px']};
        width: 50%;
    `
);

export const RightWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-left: ${spacing['8px']};
        width: 50%;
    `
);
